import { render } from "./PenSvg.vue?vue&type=template&id=3a7b553f"
const script = {}

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__